import { render, staticRenderFns } from "./roomPlayerBetslip.vue?vue&type=template&id=1f514d20&lang=pug&"
import script from "./roomPlayerBetslip.vue?vue&type=script&lang=js&"
export * from "./roomPlayerBetslip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports